<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner">
  <app-menu></app-menu>

  <div>
    <mat-card class="sobre">
      <h1 class="escolher-perfil">{{helper.hackathonNome}}</h1>
      <p class="escolher-perfil">{{helper.hackathonDescricao}}</p>

      <div *ngIf="escolherPerfil">
        <h3 align="center"> Quero participar como </h3>
        <div class="escolher-perfil">
          <button mat-raised-button class="perfil-button" (click)="userPerfil(3)">Avaliador</button>
          <button mat-raised-button class="perfil-button" (click)="userPerfil(2)">Mentor</button>
          <button mat-raised-button class="perfil-button" (click)="userPerfil(1)">Participante</button>
        </div>
      </div>

    </mat-card>
    <app-resultado *ngIf="helper.hackathonLiberarResultado"></app-resultado>
  </div>

</div>
